// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/a-minor-waltz.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const aMinorWaltz: Score = {
  slug: "a-minor-waltz",
  n: 27,
  title: "A Minor Waltz",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "A minor",
  fifths: 0,
  time: [3, 4],
  tempo: 92,
  staves: 1,
  clefs: ["treble"],
  bars: 16,
  barQuarters: 3.0,
  lowest: 68,
  highest: 76,
  hasLyrics: false,
  jasonNote: "A waltz that leans sad. Watch for the G sharp \u2014 it is not in the key signature, so it is printed on the note each time it appears. That one sharp is what gives the minor its pull home.",
  teaches: [
    "3/4 in a minor key",
    "the raised seventh",
    "reading an accidental that is not in the key signature"
  ],
  art: "/sight-reading/art/a-minor-waltz.jpg",
  artRights: "stock-free",
  background: "/sight-reading/bg/a-minor-waltz.jpg",
  newForThisEdition: true,
  fillsGap: "The printed book has no minor-key waltz, and never prints an accidental outside the key signature in a single-line piece.",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 2.0, midi: 69, pitch: "A4", d: "half" },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 2, hand: "rh", start: 3.0, dur: 2.0, midi: 72, pitch: "C5", d: "half" },
    { bar: 2, hand: "rh", start: 5.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 3, hand: "rh", start: 6.0, dur: 2.0, midi: 69, pitch: "A4", d: "half" },
    { bar: 3, hand: "rh", start: 8.0, dur: 1.0, midi: 68, pitch: "G#4", d: "quarter" },
    { bar: 4, hand: "rh", start: 9.0, dur: 3.0, midi: 69, pitch: "A4", d: "half", dot: true },
    { bar: 5, hand: "rh", start: 12.0, dur: 2.0, midi: 72, pitch: "C5", d: "half" },
    { bar: 5, hand: "rh", start: 14.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 6, hand: "rh", start: 15.0, dur: 2.0, midi: 76, pitch: "E5", d: "half" },
    { bar: 6, hand: "rh", start: 17.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 7, hand: "rh", start: 18.0, dur: 2.0, midi: 72, pitch: "C5", d: "half" },
    { bar: 7, hand: "rh", start: 20.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 8, hand: "rh", start: 21.0, dur: 3.0, midi: 69, pitch: "A4", d: "half", dot: true },
    { bar: 9, hand: "rh", start: 24.0, dur: 2.0, midi: 76, pitch: "E5", d: "half" },
    { bar: 9, hand: "rh", start: 26.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 10, hand: "rh", start: 27.0, dur: 2.0, midi: 72, pitch: "C5", d: "half" },
    { bar: 10, hand: "rh", start: 29.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 11, hand: "rh", start: 30.0, dur: 2.0, midi: 69, pitch: "A4", d: "half" },
    { bar: 11, hand: "rh", start: 32.0, dur: 1.0, midi: 68, pitch: "G#4", d: "quarter" },
    { bar: 12, hand: "rh", start: 33.0, dur: 3.0, midi: 69, pitch: "A4", d: "half", dot: true },
    { bar: 13, hand: "rh", start: 36.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 13, hand: "rh", start: 37.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 13, hand: "rh", start: 38.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 14, hand: "rh", start: 39.0, dur: 2.0, midi: 76, pitch: "E5", d: "half" },
    { bar: 14, hand: "rh", start: 41.0, dur: 1.0, midi: 72, pitch: "C5", d: "quarter" },
    { bar: 15, hand: "rh", start: 42.0, dur: 2.0, midi: 71, pitch: "B4", d: "half" },
    { bar: 15, hand: "rh", start: 44.0, dur: 1.0, midi: 68, pitch: "G#4", d: "quarter" },
    { bar: 16, hand: "rh", start: 45.0, dur: 3.0, midi: 69, pitch: "A4", d: "half", dot: true },
  ],
};
